var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('confirmation-box',{attrs:{"id":_vm.id,"main-msg":_vm.msg,"ok-msg":_vm.okMsg,"cancel-msg":_vm.cancelMsg},on:{"ok":function($event){return _vm.$emit(_vm.event);}}})}
var staticRenderFns = []

export { render, staticRenderFns }